import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiHelpCircle, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import api from '../utils/api';
import './FAQ.css';

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    fetchFAQs();
  }, []);

  const fetchFAQs = async () => {
    try {
      const response = await api.get('/faq');
      const faqsData = response.data?.data || response.data || [];
      setFaqs(Array.isArray(faqsData) ? faqsData : []);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
      setFaqs([]);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  return (
    <div className="faq page-transition">
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="container">
          <motion.div
            className="faq-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="faq-hero-title">Frequently Asked Questions</h1>
            <p className="faq-hero-subtitle">
              Find answers to common questions about our services
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          {isLoading ? (
            <div className="faq-loading">Loading FAQs...</div>
          ) : faqs.length === 0 ? (
            <div className="faq-empty">
              <p>No FAQs available yet. Check back soon!</p>
            </div>
          ) : (
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <motion.div
                  key={faq.id}
                  className="faq-item"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleFaq(faq.id)}
                  >
                    <div className="faq-question-content">
                      <FiHelpCircle className="faq-icon" />
                      <span>{faq.question}</span>
                    </div>
                    {openFaq === faq.id ? (
                      <FiChevronUp className="faq-chevron" />
                    ) : (
                      <FiChevronDown className="faq-chevron" />
                    )}
                  </button>
                  {openFaq === faq.id && (
                    <motion.div
                      className="faq-answer"
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <p>{faq.answer}</p>
                    </motion.div>
                  )}
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default FAQ;

